import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IAlertParams } from "../../types/shared";
import { scrollToTop } from "../../lib/utils";

interface IAlertState extends IAlertParams {
    show: boolean;
}

const initialState: IAlertState = {
    level: "success",
    text: "",
    show: false,
    persist: false,
};

const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers: {
        success: (state, action: PayloadAction<IAlertParams>) => {
            scrollToTop();
            state.level = "success";
            state.text = action.payload.text;
            state.title = action.payload.title;
            state.dismissible = action.payload.dismissible;
            state.settings = action.payload.settings;
            state.persist = action.payload.persist;
            state.show = true;
        },
        error: (state, action: PayloadAction<IAlertParams>) => {
            scrollToTop();
            state.level = "danger";
            state.text = action.payload.text;
            state.title = action.payload.title;
            state.dismissible = action.payload.dismissible;
            state.settings = action.payload.settings;
            state.persist = action.payload.persist;
            state.show = true;
        },
        warning: (state, action: PayloadAction<IAlertParams>) => {
            scrollToTop();
            state.level = "warning";
            state.text = action.payload.text;
            state.title = action.payload.title;
            state.dismissible = action.payload.dismissible;
            state.settings = action.payload.settings;
            state.persist = action.payload.persist;
            state.show = true;
        },
        info: (state, action: PayloadAction<IAlertParams>) => {
            scrollToTop();
            state.level = "info";
            state.text = action.payload.text;
            state.title = action.payload.title;
            state.dismissible = action.payload.dismissible;
            state.settings = action.payload.settings;
            state.persist = action.payload.persist;
            state.show = true;
        },
        clear: state => {
            state.text = "";
            state.title = undefined;
            state.dismissible = undefined;
            state.settings = undefined;
            state.show = false;
        },
    },
});

export const alertActions = { ...alertSlice.actions };

export default alertSlice.reducer;
